import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    data: {
      title: ''
    },
    loadChildren: () =>
      import('./topbar-problem/topbar-problem.module').then((m) => m.TopbarProblemModule),
  },
  {
    path: 'list',
    data: {
      title: ''
    },
    loadChildren: () =>
      import('./list/list.module').then((m) => m.ListModule),
  },
  /*
  // Page not found
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [MsalGuard]
  }, */
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'top',
      initialNavigation: 'enabledNonBlocking', // Remove this line to use Angular Universal
      paramsInheritanceStrategy: 'always' // Important
    })
  ],
  exports: [RouterModule],
  providers: [
  ]
})
export class AppRoutingModule { }
